import { Icon } from '../../../../../../shared/';
import './selected-icon.scss';

export const SelectedIcon = () => <Icon className="selected-icon" type="checkmark" size={2.5} fill="#00816D" />;
